import { Avatar, Box, Typography } from "@mui/material";

import { useUserDataFormatter } from "../../../User/hooks/useUserDataFormatter";

import { ServiceFeedback } from "../../types/service.type";
import { GoldenStarIcon } from "../../assets/icons/go-service-icons";

const headerStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  userInfoContainer: {
    display: "flex",
    gap: "12px",
  },
  avatar: {
    width: "48px",
    height: "48px",
  },
  userDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  userName: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  userRole: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
  ratingContainer: {
    display: "flex",
    gap: "4px",
  },
};

const ServiceFeedbackCardHeader = ({ feedback }: { feedback: ServiceFeedback }) => {
  const { user } = feedback;
  const { fullName, media, firstTwoChr, role, club } = useUserDataFormatter(user);

  const rating = 4;
  return (
    <Box sx={headerStyles.container}>
      <Box sx={headerStyles.userInfoContainer}>
        <Avatar src={media} alt={fullName} sx={headerStyles.avatar}>
          {firstTwoChr}
        </Avatar>
        <Box sx={headerStyles.userDetailsContainer}>
          <Typography sx={headerStyles.userName}>{fullName}</Typography>
          <Typography sx={headerStyles.userRole}>
            {role} {club && `• ${club}`}
          </Typography>
        </Box>
      </Box>
      <Box sx={headerStyles.ratingContainer}>
        {Array.from({ length: rating }).map((_, index) => (
          <GoldenStarIcon key={index} />
        ))}
      </Box>
    </Box>
  );
};

export default ServiceFeedbackCardHeader;
